import React from "react";
import PropTypes from "prop-types";

const AdditionalText = ({
    text
}) => {
  return (
    <div>{text}</div>
  );
};

AdditionalText.propTypes = {
  text: PropTypes.string
};

export default AdditionalText;



// WEBPACK FOOTER //
// ./src/components/help/AdditionalText/index.js